export default {
  namespaced: true,
  state: {
    closeVisible: true,
    changeSystemVisible: true,
  },
};
